var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// ./~/victory-legend/~/lodash/_Promise.js
// module id = ./node_modules/victory-legend/node_modules/lodash/_Promise.js
// module chunks = 1